<template>
    <module-card :nextDisabled="nextDisabled" ref="moduleCard">
        <p class="text-h6">
            The Setting: <span class="sexy-setting">{{ sexySetting.setting }}</span>
        </p>
        <p>Threat 1: {{ sexySetting.threat1 }}</p>
        <p>Threat 2:</p>
        <div v-for="threat in threatChoices" :key="threat.id" @click.stop="select(threat)" class="grey pa-3 mb-1 response" :class="{ 'lighten-3': !(threat.id === selectedThreatId) }" v-ripple>
            <span :class="{ 'threat-selected': threat.selected }">{{ threat.threat }}</span>
        </div>
        <slot></slot>
        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </module-card>
</template>

<script>
    import { keyBy, filter, shuffle } from 'lodash';

    export default {
        data() {
            return {
                selectedThreatId: null,
                incorrectMessages: ['Good try, give it another shot', 'Not Quite! Try again', 'Close!'],
                correctFeedback: `That's correct!`,
                sexySettingsThreats: [
                    {
                        id: 1,
                        threat: `Cramped seating and hard to properly put on a condom or lube`,
                        selected: false
                    },
                    {
                        id: 2,
                        threat: `May not have condom handy in the outdoors.`,
                        selected: false
                    },
                    {
                        id: 3,
                        threat: `Might be in a toilet stall, where it’s too hard to put on a condom or lube`,
                        selected: false
                    },
                    {
                        id: 4,
                        threat: `They might feel “rude” asserting themselves.`,
                        selected: false
                    },
                    {
                        id: 5,
                        threat: `They might drink or smoke more than usual because they’re feeling comfortable at their own place.`,
                        selected: false
                    },
                    {
                        id: 6,
                        threat: `They might be feeling really nervous (because they might get arrested), and not use safer sex.`,
                        selected: false
                    },
                    {
                        id: 7,
                        threat: `The client/trick says he won’t honor his side of the deal unless they have sex without a condom`,
                        selected: false
                    }
                ],
                sexySettings: keyBy(
                    [
                        {
                            id: 1,
                            setting: `A Car`,
                            threat1: `Too dark to check expiration date on condom`,
                            threat2id: 1
                        },
                        {
                            id: 2,
                            setting: `A public park at night`,
                            threat1: `May not know the person they’re hooking up with.`,
                            threat2id: 2
                        },
                        {
                            id: 3,
                            setting: `A public restroom during the day`,
                            threat1: `Might have to be really quiet so can’t talk about safer sex.`,
                            threat2id: 3
                        },
                        {
                            id: 4,
                            setting: `The home of an older sex partner`,
                            threat1: `Their hook-up might be more experienced than them, and not into condoms`,
                            threat2id: 4
                        },
                        {
                            id: 5,
                            setting: `Their own home (they live alone)`,
                            threat1: `Their personal stash of condoms might be empty.`,
                            threat2id: 5
                        },
                        {
                            id: 6,
                            setting: `A cruising spot heavily patrolled by police`,
                            threat1: `Might have to be really quiet so can’t talk about safer sex.`,
                            threat2id: 6
                        },
                        {
                            id: 7,
                            setting: `The car of a trick/client (consider this from a sex worker’s perspective)`,
                            threat1: `The client/trick locks them in the car and won’t let them out unless you do what he says`,
                            threat2id: 7
                        }
                    ],
                    'id'
                )
            };
        },
        props: {
            setting: {
                type: Number,
                required: true
            }
        },
        computed: {
            sexySetting() {
                return this.sexySettings[this.setting];
            },
            threatChoices() {
                // return the threats that haven't been selected yet;
                // this is just any threat with an id >= the current setting id
                // want to randomize so these choices aren't displayed in the same order on every screen
                // TODO: what if they go back?
                return shuffle(
                    filter(this.sexySettingsThreats, (t) => {
                        return parseInt(t.id) >= parseInt(this.setting);
                    })
                );
            }
        },
        methods: {
            nextDisabled() {
                return !(this.sexySetting.threat2id === this.selectedThreatId);
            },
            select(threat) {
                if (threat.id != this.sexySetting.threat2id) {
                    this.selectedThreatId = null;
                    this.$refs.modalFeedback.show(false, shuffle(this.incorrectMessages)[0], () => {
                        threat.selected = true;
                    });
                } else {
                    this.$refs.modalFeedback.show(true, this.correctFeedback, () => {
                        this.selectedThreatId = threat.id;
                        this.$refs.moduleCard.nextClick();
                    });
                }
            }
        }
    };
</script>

<style scoped>
    .sexy-setting {
        color: darkblue;
    }
    .threat-selected {
        text-decoration: line-through;
        text-decoration-color: red;
    }
</style>
